module.exports = __webpack_public_path__ + "img/ic_chevron_circle_back.8d3fc497.svg";